import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

import IconHide from './IconHide';

/**
 * Header row of the timeline. Renders the "Shifts" label and the
 * hour ruler. The eye icon next to "Shifts" is a master visibility
 * toggle for every shift below (matches the per-row eye in DriverList).
 */
const DriverTime = ({ hours, oneHourPx, hasShifts, allHidden, onClickHideAll }) => {
  const { t } = useTranslation('routes');
  return (
    <div
      className="tr"
      style={{
        minWidth: hours.length * oneHourPx,
        width: '100%',
      }}
    >
      <div className="td">
        <div className="driver-name all-drivers" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <b>{t('shifts')}</b>
          {hasShifts && (
            <Tooltip title={allHidden ? t('unhideAllShifts') : t('hideAllShifts')}>
              <span style={{ cursor: 'pointer', display: 'inline-flex' }}>
                <IconHide isHide={allHidden} onClickHide={onClickHideAll} />
              </span>
            </Tooltip>
          )}
        </div>
      </div>
      <div className="td">
        {hours.map((hour, index) => {
          return (
            <div className="time" key={index} style={{ width: `${oneHourPx}px` }}>
              {String(hour).padStart(2, '0')}:00
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DriverTime;
